var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elektra-wrap"},[(_vm.headerInterfaceActive)?_c('ElektrizateHeaderInterface'):_vm._e(),_c('router-view'),(_vm.$route.meta.menu)?_c('ElektrizateMenuNav'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }